import requester from '@/lib/axios';
import { TrueOrFalseDTO, TrueOrFalseQuestion } from '@/models/Question';

const baseUrl = 'true-or-false-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

export const getTrueOrFalseQuestion = async (id: number) => {
  const { data } = await requester().get<TrueOrFalseQuestion>(
    `${baseUrl}/${id}/`,
  );

  return data;
};

export const updateTrueOrFalseQuestion = async (
  id: number,
  changes: TrueOrFalseDTO,
) => {
  const { data } = await requester().patch<TrueOrFalseQuestion>(
    `${baseUrl}/${id}/`,
    changes,
  );

  return data;
};

export const deleteTrueOrFalseQuestion = async (id: number) => {
  await requester().delete<TrueOrFalseQuestion>(`${baseUrl}/${id}/`);
};

export const createTrueOrFalseQuestion = async (body: TrueOrFalseDTO) => {
  const { data } = await requester().post<TrueOrFalseQuestion>(
    `${baseUrl}/`,
    body,
  );

  return data;
};

export const createTrueOrFalseQuestionIntoActivity = async (
  activityId: number,
  body: TrueOrFalseDTO,
) => {
  const { data } = await requester().post<TrueOrFalseQuestion>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateTrueOrFalseQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: TrueOrFalseDTO,
) => {
  const { data } = await requester().patch<TrueOrFalseQuestion>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};

export const deleteTrueOrFalseQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
